import { AbsenceOccurrence } from '../../../types/absence'
import { getLocalDateString } from '../../../utils/date-utils'

interface Props {
  absence: AbsenceOccurrence
  totalHoursLost: number
}

function AbsenceDetailsSection({ absence, totalHoursLost }: Props) {
  return (
    <>
      <h3>Period Of Absence (Including non-working days from the first day of absence)</h3>
      <p>
        {getLocalDateString(absence.startDate)}
        {' - '}
        {getLocalDateString(absence.endDate)}
      </p>
      <br />
      <h3>Total number of hours absent</h3>
      <p>{totalHoursLost}</p>
      <br />
      <h3>Total Number of days absent</h3>
      <p>{absence.absenceDays.length}</p>
      <br />
      <h3>Of which resulted in absence from work</h3>
      <p>{absence.absenceDays.length}</p>
      <br />
      <h3>Absence Reason</h3>
      <p>{absence.reason}</p>
      <br />
      <h3>Absence Classification</h3>
      <p>{absence.absenceDays[0].absenceType.reasonType}</p>
      <br />
    </>
  )
}

export default AbsenceDetailsSection